"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _antd = require("antd");
var _signInForm = _interopRequireDefault(require("./sign-in-form.js"));
var _signUpForm = _interopRequireDefault(require("./sign-up-form.js"));
var _recoverPasswordForm = _interopRequireDefault(require("./recover-password-form.js"));
var _resetPasswordForm = _interopRequireDefault(require("./reset-password-form.js"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var WrappedSignIn = _antd.Form.create({
  name: "normal_login"
})(_signInForm["default"]);
var WrappedSignUp = _antd.Form.create({
  name: "create_account"
})(_signUpForm["default"]);
var WrappedRecoverPass = _antd.Form.create({
  name: "recover_pass"
})(_recoverPasswordForm["default"]);
var WrappedResetPassForm = _antd.Form.create({
  name: "reset_pass"
})(_resetPasswordForm["default"]);
var FormSwitcher = /*#__PURE__*/function (_React$Component) {
  _inherits(FormSwitcher, _React$Component);
  var _super = _createSuper(FormSwitcher);
  function FormSwitcher(props) {
    var _this;
    _classCallCheck(this, FormSwitcher);
    _this = _super.call(this, props);
    _this.state = {
      form: props.form
    };
    return _this;
  }
  _createClass(FormSwitcher, [{
    key: "formSwitcher",
    value: function formSwitcher(e, form) {
      e.preventDefault();
      this.setState({
        form: form
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      switch (this.state.form) {
        case "SignIn":
          this.form = /*#__PURE__*/_react["default"].createElement(WrappedSignIn, {
            formSwitcher: function formSwitcher(e, form) {
              _this2.formSwitcher(e, form);
            },
            signIn: this.props.signIn
          });
          break;
        case "SignUp":
          this.form = /*#__PURE__*/_react["default"].createElement(WrappedSignUp, {
            formSwitcher: function formSwitcher(e, form) {
              _this2.formSwitcher(e, form);
            },
            signUp: this.props.signUp
          });
          break;
        case "RecoverPassword":
          this.form = /*#__PURE__*/_react["default"].createElement(WrappedRecoverPass, {
            formSwitcher: function formSwitcher(e, form) {
              _this2.formSwitcher(e, form);
            },
            recoverPass: this.props.recoverPass
          });
          break;
        case "ResetPassword":
          this.form = /*#__PURE__*/_react["default"].createElement(WrappedResetPassForm, {
            formSwitcher: function formSwitcher(e, form) {
              _this2.formSwitcher(e, form);
            },
            resetPass: this.props.resetPass
          });
          break;
        default:
          break;
      }
      return this.form;
    }
  }]);
  return FormSwitcher;
}(_react["default"].Component);
var _default = exports["default"] = FormSwitcher;